import React, { useContext } from 'react';
import moment from 'moment';
import * as _ from 'lodash';
import uuidv4 from 'uuid/v4';
import Button from 'antd/lib/button';
import {ModelContext} from "../metadata/ModelSource";
import { DriversAndVehiclesDataReportContext } from '../../context/DriversAndVehiclesDataReportProvider';
import { dateToString, DATE_FORMAT } from '../../utils/dateUtils';

export const addBean = (path, proto, applicationModel) => {
  const tempId = uuidv4(); // ⇨ '1b9d6bcd-bbfd-4b2d-9b5d-ab8dfbbd4bed'

  let container = applicationModel.getValue(path);
  if (container === undefined) {
    container = [];
    applicationModel.setValue(path, container);
  }
  container.push({
    ..._.cloneDeep(proto),
    _tempId: tempId,
    status: 'Active'
  });

  // Add start date to newly added drivers
  if (proto.partyTypeCd && proto.partyTypeCd === 'DriverParty') {
    const date = moment(new Date(), DATE_FORMAT);
    const stringDate = dateToString(date);
    const currentBean = container.length - 1;

    applicationModel.setValue(`drivers[${currentBean}].driverInfo.driverStartDt`, stringDate);
  }
  return applicationModel.modification();
};

const setExpand = (path, setExpandDrivers, setExpandRisks)=>{
  if (path.indexOf('drivers') !== -1){
    setExpandDrivers(false);
  }else {
    setExpandRisks(false);
  }
}

export function AddBeanBtn({ path, proto, label, ...props }) {
  const applicationModel = useContext(ModelContext);
  const {setExpandDrivers, setExpandRisks} = useContext(DriversAndVehiclesDataReportContext);
  return <Button className="secondary-button" style={{ marginRight: '10px' }} onClick={() => {
    addBean(path, proto, applicationModel);
    setExpand(path, setExpandDrivers, setExpandRisks);
  }
  } {...props} >{label}</Button>
}


export function AddBeanBtnTertiary({path, proto, label, ...props}) {
  const applicationModel = useContext(ModelContext);
  const {setExpandDrivers, setExpandRisks} = useContext(DriversAndVehiclesDataReportContext);
  return <Button type='link' onClick={() => {
    addBean(path, proto, applicationModel);
    setExpand(path, setExpandDrivers, setExpandRisks)
  }
  } {...props} >{label}</Button>
}
